import './landing.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import LandingPage from '../components/landing/LandingPage'

const root = document.getElementById('landing-page')

if (root) {
  createRoot(root).render(
    <StrictMode>
      <LandingPage pagarmePublicKey={root.dataset.pagarmePublicKey} />
    </StrictMode>
  )
}
